import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Chi Siamo', id: 'chi-siamo' },
  { label: 'Servizi', id: 'servizi' },
  { label: 'Recensioni', id: 'recensioni' },
  { label: 'Contatti', id: 'contatti' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMobileOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-3 cursor-pointer"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-orange-500 rounded-lg">
            <i className="ri-fire-fill text-white text-lg"></i>
          </div>
          <div className="text-left">
            <p className={`font-bold text-sm leading-tight transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              Stufe a Pellet
            </p>
            <p className={`font-semibold text-xs leading-tight transition-colors ${scrolled ? 'text-orange-500' : 'text-orange-300'}`}>
              Ravenna
            </p>
          </div>
        </button>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-orange-500' : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA + Hamburger */}
        <div className="flex items-center gap-3">
          <a
            href="tel:+393806328251"
            className="hidden md:flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm"></i>
            </div>
            Chiama Ora
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center transition-colors cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-left text-gray-700 font-medium text-sm py-3 border-b border-gray-50 last:border-0 cursor-pointer hover:text-orange-500 transition-colors"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:+393806328251"
            className="mt-2 flex items-center justify-center gap-2 bg-orange-500 text-white text-sm font-semibold py-3 rounded-full cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm"></i>
            </div>
            +39 380 632 8251
          </a>
        </div>
      )}
    </nav>
  );
}
